import styled, { css } from 'styled-components';
import { baseVariables, getStyleClassPerTheme, toRem } from '@marriott/mi-ui-library';

const borderRadius = toRem(14);
const gradientStandard =
  'linear-gradient(270deg, rgba(255, 255, 255, 0) 27%, rgba(255, 255, 255, 0.52) 49%, rgba(255, 255, 255, 0.52) 100%)';

const gradientInverse = `
  linear-gradient(
    to right,
    rgba(0, 0, 0, 0.54) 0%,
    rgba(0, 0, 0, 0.54) 50%,
  rgba(0,0,0, 0) 75%,
    rgba(0,0,0, 0) 100%
  );
`;
const gradientSquareStandard = `linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.54) 17.8%, rgba(255, 255, 255, 0.54) 100%)`; // baseGradient01 adjacent
const gradientSquareInverse = `linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 17.8%, rgba(0, 0, 0, 0.54) 100%)`; // baseGradient05 adjacent

export const StyledPhotoCaption = styled.div`
  gap: ${toRem(4)};
  background: rgba(0, 0, 0, 0.54);
  position: absolute;
  top: ${toRem(16)};
  left: ${toRem(16)};
  border-radius: ${toRem(4)};
  backdrop-filter: blur(${toRem(2)});
  z-index: 2;
  display: none;

  .icon {
    color: ${baseVariables.color['base20']};
  }

  @media ${baseVariables.mediaQuery.md} {
    display: flex;
    left: auto;
    right: ${toRem(16)};
  }
`;

export const StyledPhotoCaptionText = styled.span`
  color: ${baseVariables.color['base20']} !important; // !important added to override color from style class t-font-xs
  font-weight: 700;
`;

/** Matches MTextBlockSimple layout (flex column + alignment). */
export const LayeredFeatureTextBlockWrapper = styled.div<{ $centered?: boolean }>`
  text-align: ${({ $centered }) => ($centered ? 'center' : 'left')};
`;

export const StyledMerchandisingLayeredFeature = styled.div<{ $theme: string | undefined; $type: 'cf' | 'dca' }>(
  ({ $theme }) => {
    const themeClass = getStyleClassPerTheme($theme);
    const isStandard = themeClass === 'standard';

    return css`
      position: relative;
      overflow: hidden;
      aspect-ratio: 1;
      border-radius: ${toRem(14)};

      @media ${baseVariables.mediaQuery.md} {
        aspect-ratio: 2;
      }

      @media ${baseVariables.mediaQuery.xl} {
        aspect-ratio: 3;
      }

      .m-button-primary.icon-trailing :not(.btn-label),
      .m-button-secondary.icon-trailing :not(.btn-label) {
        display: none;
      }

      .lyrd_ft {
        &__cta-cnt {
          gap: ${toRem(8)};
        }

        &__cnt-wrapper {
          z-index: 1;

          .logo-icon {
            aspect-ratio: 3 / 2;
            height: ${toRem(60)};
            max-width: ${toRem(90)};
            justify-content: left;

            @media ${baseVariables.mediaQuery.lg} {
              height: ${toRem(90)};
              max-width: ${toRem(135)};
            }
          }

          .logo-icon::before {
            font-size: ${toRem(50)};
            line-height: ${toRem(50)};

            @media ${baseVariables.mediaQuery.lg} {
              font-size: ${toRem(80)};
              line-height: ${toRem(80)};
            }
          }

          .credit-card-image {
            height: 100%;
            max-height: ${toRem(118)};
            max-width: 100%;
            width: auto;
          }

          .logo-image {
            height: 100%;
            max-height: ${toRem(60)};
            max-width: 100%;
            width: auto;

            @media ${baseVariables.mediaQuery.lg} {
              max-height: ${toRem(90)};
            }
          }
        }

        &__feature-img {
          border-radius: ${borderRadius};

          &-wrapper {
            height: 100%;
            width: 100%;
          }
        }

        &__gradient {
          position: relative;

          &:after {
            height: 100%;
            z-index: 0;
            display: block;
            width: 100%;
            position: absolute;
            content: '';
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: ${borderRadius};
            background: ${isStandard ? gradientSquareStandard : gradientSquareInverse};

            @media ${baseVariables.mediaQuery.md} {
              background: ${isStandard ? gradientStandard : gradientInverse};
            }
          }
        }

        &__cnt-sec {
          position: absolute;
          z-index: 1;
          top: 0;
          bottom: 0;
          right: ${toRem(8)};
          left: ${toRem(8)};
          align-items: flex-end;

          &:before {
            display: none;
          }

          @media ${baseVariables.mediaQuery.md} {
            align-items: center;
          }
        }

        &__cnt-ctr {
          position: relative;
          z-index: 1;
        }

        &__txt-cnt {
          padding-top: ${toRem(16)};
          padding-bottom: ${toRem(16)};
        }

        &.cobrand-banner .lyrd_ft__txt-cnt {
          padding-top: ${toRem(4)};
          padding-bottom: ${toRem(4)};
        }

        &__credit-card-img {
          width: ${toRem(150)};
          height: auto;

          &--sm {
            width: ${toRem(66)};

            @media ${baseVariables.mediaQuery.md} {
              width: ${toRem(100)};
            }
          }
        }

        &__legal {
          margin-top: ${toRem(8)};
          color: ${baseVariables.color['neutral50']};
        }
      }
    `;
  }
);
